const PLATFORM_GRADIENTS = [
  ['#0ea5a5', '#22c55e'],
  ['#14b8a6', '#84cc16'],
  ['#eab308', '#a3e635'],
  ['#f59e0b', '#facc15'],
  ['#1c1c1c', '#3a3a3a'],
  ['#6366f1', '#8b5cf6'],
];

function hashString(value) {
  let hash = 0;
  const text = String(value || '');
  for (let i = 0; i < text.length; i += 1) {
    hash = ((hash << 5) - hash) + text.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash);
}

export function platformInitial(tool) {
  const name = String(tool?.name || tool?.key || 'P').trim();
  return name.slice(0, 1).toUpperCase() || 'P';
}

export function platformIconSvgDataUrl(tool) {
  const label = platformInitial(tool);
  const key = String(tool?.key || tool?.name || 'platform').trim().toLowerCase();
  const [start, end] = PLATFORM_GRADIENTS[hashString(key) % PLATFORM_GRADIENTS.length];
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" role="img" aria-hidden="true">
    <defs>
      <linearGradient id="g" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stop-color="${start}"/>
        <stop offset="100%" stop-color="${end}"/>
      </linearGradient>
    </defs>
    <rect x="6" y="6" width="68" height="68" rx="18" fill="url(#g)"/>
    <circle cx="62" cy="20" r="10" fill="rgba(255,255,255,0.16)"/>
    <circle cx="22" cy="60" r="16" fill="rgba(0,0,0,0.10)"/>
    <text x="40" y="48" text-anchor="middle" font-family="Inter,Segoe UI,Arial,sans-serif" font-size="30" font-weight="700" fill="rgba(255,255,255,0.92)">${label}</text>
  </svg>`;
  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
}

export function resolveAvatarInitials(displayName, email) {
  const source = String(displayName || email || 'HK').trim();
  const parts = source.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0].slice(0, 1)}${parts[1].slice(0, 1)}`.toUpperCase();
  }
  return source.slice(0, 2).toUpperCase();
}

const CUSTOMER_ACCOUNT_STORAGE_KEY = 'hk-identity-selected-customer-account';

export function readStoredCustomerAccountId() {
  try {
    return String(localStorage.getItem(CUSTOMER_ACCOUNT_STORAGE_KEY) || '').trim();
  } catch {
    return '';
  }
}

export function writeStoredCustomerAccountId(accountId) {
  try {
    if (!accountId) {
      localStorage.removeItem(CUSTOMER_ACCOUNT_STORAGE_KEY);
      return;
    }
    localStorage.setItem(CUSTOMER_ACCOUNT_STORAGE_KEY, String(accountId));
  } catch {
    // ignore storage errors
  }
}
